import { Button } from '@material-ui/core';
import { useEffect } from 'react';
import en from '../../../../lang/en-us';
import SuccessScreen from '../SuccessScreen';
const { dashboard } = en;

export default function UpdateIFSCSuccess(props: any) {
    const { reqId } = props.location.state || {};

    useEffect(() => {
        if (!props.location.state) {
            props.history.push('/');
        }
    }, []);

    return (
        <div className="curved-bg">
            <SuccessScreen
                heading={dashboard.UpdateForm15.Success.back}
                backLink="nct/update-ifsc-otp"
                info1={dashboard.UpdateForm15.Success.subHeadingInfo1}
                infospan2={`${reqId}`}
                info3={dashboard.UpdateForm15.Success.subHeadingInfo3}
                list={[]}
                handleClick={() => props.history.push('/portal/track')}
            />
        </div>
    );
}
